var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-bill-lot-operate',{staticClass:"pt-bill-lot-operate__page"})}
var staticRenderFns = []

export { render, staticRenderFns }